// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + chunkId + "." + {"60":"5da4b17d14","253":"33be729015","619":"cd283322e3"}[chunkId] + ".js";
};